import {
  Button, Card,
  CardActions,
  CardContent, CardHeader, CircularProgress,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Accordion,
  AccordionDetails, AccordionSummary, List, ListItem, ListItemAvatar, ListItemText, Paper, Table, TableBody,
  TableCell, TableContainer, TableRow, Typography
} from '@material-ui/core';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AudioAnalyzer from 'src/components/AudioAnalyzer';
import axios from 'src/utils/axios';
import { getTokenWs, getUser, openBlob } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0
  },
  contentMin: {
    padding: 0,
    minHeight: 390,
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  avatar: {
    backgroundColor: '#424242',
  }

}));

function Yardimci({ className, FisNo, tasks, readonly }) {
  const classes = useStyles();
  const [YardimciData, setYardimciData] = useState([]);
  const [YardimciDataLibrary, setYardimciDataLibrary] = useState([]);
  const [YardimciDataLibraryDetail, setYardimciDataLibraryDetail] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [AudioAnalyzerOpen, setAudioAnalyzerOpen] = React.useState(false);

  const SessionUser = getUser();

  let YardimciDataDeger = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

  if (!readonly && (!YardimciDataDeger || YardimciDataDeger.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      YardimciDataDeger = loadBaslandiJob();
    }
  }

  // Güvenli array erişimi için kontrol
  const firstItem = (Array.isArray(YardimciDataDeger) && YardimciDataDeger.length > 0) ? YardimciDataDeger[0] : {};

  var KulModelKodu = firstItem?.KUL_MODEL_KODU;
  var Uyil = firstItem?.UYIL;
  var Udonem = firstItem?.UDONEM;
  var SeriNo = firstItem?.SERINO;
  var NitelikKodu = firstItem?.NITELIK_KODU;
  var Barcode = firstItem?.BARKOD;
  useEffect(() => {
    let mounted = true;
    const fetchLogs = () => {
      axios.get('/GetArtemisTechnicianHelper/' + (KulModelKodu || '-1')).then(response => {
        if (mounted) {
          const Deger = response.data === "" ? [] : response.data;
          setYardimciData(Deger);

        }
      }).catch(error => {
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });

      if (!KulModelKodu) {
        setYardimciDataLibrary([]);
        setLoading(false);
        return;
      }

      axios.get('/GetArtemisLibrary/' + KulModelKodu).then(response => {
        if (mounted) {
          const DegerLibrary = response.data === "" ? [] : response.data;
          setYardimciDataLibrary(DegerLibrary);
          setLoading(false);
        }
      }).catch(error => {
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
    }
    fetchLogs();
    return () => {
      mounted = false;
    };
  }, [KulModelKodu]);

  const GetLibraryDetail = (panel) => {
    setLoading(true);
    axios.get('/GetArtemisDetailLibrary/' + KulModelKodu + '/' + panel).then(response => {
      const Deger = response.data === "" ? [] : response.data;
      setYardimciDataLibraryDetail(Deger);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
            logger.error("Hata detayı:", error.message);
    });
  };

  const DetayAc = (log) => {
    setLoading(true);
    const data = {
      BIRIM_KODU: SessionUser.ServiceShopId.toString(),
      SICIL_NO: SessionUser.UserId,
      FilePtr: log.FP,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/ArtemisBulten', data, config)
      .then(response => {
        openBlob(response.data, log.BK + '_' + log.BN);
        setLoading(false);
      }).catch(error => {
        setUyari("Bülten açılamadı!..5");
        setOpen(true);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if (isExpanded === true) {
      GetLibraryDetail(panel);
    }

  };

  const handleOpenTHelper = (event, Link) => {
    event.persist();
    if (!Link) {
      setUyari("Yardımcı linki bulunamadı!");
      setOpen(true);
      return;
    }
    window.open(Link, "_blank");
  };


  const IOTKartEslemeAc = (event) => {
    if (Barcode === "0" || Barcode === "" || Barcode === undefined) {

      if (KulModelKodu === undefined || KulModelKodu === "0" || KulModelKodu === "") {
        setUyari("Lütfen önce Barkod okutunuz yada Ürün bilgilerini giriniz!...");
        setOpen(true);
        return;
      }
      if (Udonem === undefined || Udonem === "0" || Udonem === "") {
        setUyari("Lütfen önce Barkod okutunuz yada Ürün bilgilerini giriniz!...");
        setOpen(true);
        return;
      }
      if (Uyil === undefined || Uyil === "0" || Uyil === "") {
        setUyari("Lütfen önce Barkod okutunuz yada Ürün bilgilerini giriniz!...");
        setOpen(true);
        return;
      }
      if (SeriNo === undefined || SeriNo === "0" || SeriNo === "") {
        setUyari("Lütfen önce Barkod okutunuz yada Ürün bilgilerini giriniz!...");
        setOpen(true);
        return;
      }

      if (Udonem.toString().length === 1) {
        Udonem = "0" + Udonem;
      }
      if (NitelikKodu === "0") {
        NitelikKodu = "02";
      } else {
        NitelikKodu = "01";
      }
      Barcode = KulModelKodu + Uyil.toString().substring(2, 4) + SeriNo.toString() + Udonem.toString() + NitelikKodu.toString();
    }

    if (Barcode === "0" || Barcode === "" || Barcode === undefined) {
      setUyari("Lütfen önce Barkod okutunuz!...");
      setOpen(true);
      return;
    }

    event.persist();
    let SessionTokenWs = getTokenWs();
    var Link = process.env.REACT_APP_IOT_URL;

    if (!Link) {
      setUyari("IOT servisi şu anda kullanılamıyor!");
      setOpen(true);
      return;
    }

    Link = Link + "?SessionToken=" + SessionTokenWs + "&Barcode=" + Barcode;
    window.open(Link);
    event.persist();
  }

  const handleOpenVideoCall = () => {
    const baseUrl = process.env.REACT_APP_REMOTE_HELP_URL;

    if (!baseUrl) {
      setUyari("Görüntülü görüşme servisi tanımlı değil!");
      setOpen(true);
      return;
    }

    const VideoCallUser = SessionUser.ServiceShopCode + '-' + SessionUser.NameSurname;
    const VideoCallServicePaper = FisNo;

    const Link = baseUrl + "?UserId=" + VideoCallUser + "|" + VideoCallServicePaper;
    window.open(Link, "_blank");
  }

  const user = getUser();
  let user_types = user.TechnicianType.split(",");
  let klima_teknisyeni = false;
  user_types && user_types.forEach(u => {
    if (parseInt(u.TIP) === 26) {
      klima_teknisyeni = true;
    }
  });
  if (klima_teknisyeni) {
    return <Card>
      <CardHeader title="Yetki Kontrolü" />
      <Divider />
      <CardContent className={classes.contentMin}>
        Yetkiniz bulunmadığı için sayfa görüntülenemiyor!..
      </CardContent>
    </Card>;
  }

  const handleClose = () => {
    setOpen(false);
  };


  const handleAudioAnalyzerClose = () => {
    setAudioAnalyzerOpen(false);
  };


  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {"Bilgilendirme"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={AudioAnalyzerOpen}
        onClose={handleAudioAnalyzerClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {"Sesten Arıza Analizi"}
        </DialogTitle>
        <DialogContent>
          <AudioAnalyzer />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAudioAnalyzerClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {window.navigator.onLine ?
        <div className={clsx(classes.root, className)}>
          <Card>
            <CardHeader
              title="Teknisyen Yardımcısı" />
            <Divider />
            {
              Loading ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                : <div></div>
            }
            <CardContent className={classes.content}>
              <List className={classes.root}>
                {Array.isArray(YardimciData) && YardimciData.map(itemYardimci => (
                  <div key={itemYardimci.ACIKLAMA}>
                    <ListItem alignItems="flex-start"
                      onClick={(event) => handleOpenTHelper(event, itemYardimci.LINK)}>
                      <ListItemAvatar>
                        <AccessibilityNewIcon style={{ color: "#FF9800" }} />
                      </ListItemAvatar>
                      <ListItemText primary={itemYardimci.ACIKLAMA} />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </div>
                ))}
              </List>
            </CardContent>
          </Card>
          {/* <Card>
            <CardHeader title="Sesten Arıza Tanıma" />
            <Divider />
            <CardContent className={classes.content}>
              <List className={classes.root}>
                <ListItem alignItems="flex-start"
                  onClick={(event) => setAudioAnalyzerOpen(true)}>
                  <ListItemAvatar>
                    <AudioAnalyzerIcon style={{ color: "#FF9800" }} />
                  </ListItemAvatar>
                  <ListItemText primary={"Sesten Arıza Tanıma"} />
                </ListItem>
              </List>
            </CardContent>
          </Card> */}

          <Card>
            <CardHeader title="IOT İşlemler" />
            <Divider />
            <CardContent className={classes.content}>
              <List className={classes.root}>
                <ListItem alignItems="flex-start"
                  onClick={(event) => IOTKartEslemeAc(event)}>
                  <ListItemAvatar>
                    <SettingsInputAntennaIcon style={{ color: "#FF9800" }} />
                  </ListItemAvatar>
                  <ListItemText primary={"IOT Log Listeleme ve IOT Cihaz-Kart eşlemesi"} />
                </ListItem>
              </List>
            </CardContent>
          </Card>
          <Card className={classes.contentMin}>
            <CardHeader title="E-Kütüphane" />
            {Array.isArray(YardimciDataLibrary) && YardimciDataLibrary.map(log => (
              <Accordion key={log.ACIKLAMA} expanded={expanded === log.BANKATIPI} onChange={handleChange(log.BANKATIPI)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >

                  <ListItemAvatar>
                    <LocalLibraryIcon style={{ color: "#FF9800" }} />
                  </ListItemAvatar>
                  <Typography className={classes.secondaryHeading}>{log.ACIKLAMA + '-' + log.ADET}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper}>
                    {/* {
                      Loading ?
                        <CircularProgress
                          status={'loading'}
                          style={{ marginLeft: '50%' }}
                        />
                        : <div></div>
                    } */}
                    <Table className={classes.table} aria-label="simple table">
                      <TableBody>
                        {Array.isArray(YardimciDataLibraryDetail) && YardimciDataLibraryDetail.map(row => (
                          <TableRow
                            key={row.A}
                          >
                            <TableCell component="th"
                              onClick={() => DetayAc(row)}
                              scope="row">
                              {row.A}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            )
            )}
          </Card>
          <Card>
            <CardHeader title="Görüntülü Görüşme" />
            <Divider />
            <CardActions>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={(event) => handleOpenVideoCall(event)}
                endIcon={<VideoCallIcon>Close</VideoCallIcon>}>
                Başlat
              </Button>
            </CardActions>
          </Card>
        </div>
        :
        <Card className={clsx(classes.root, className)}>
          <CardHeader title="Teknisyen Yardımcısı" />
          <CardContent className={classes.contentMin}>
            Offline oldugunuz için görüntüme yapılamıyor lütfen online moda geçtikten sonra tekrar deneyiniz!...
          </CardContent>
        </Card>
      }
    </div>
  );
}

Yardimci.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(Yardimci);
